import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";
import s from "~/components/Table/TableRow/EditorIndicatorsTableRow/TableRow.less";

const renderCellWithPeriod = (
  value: any,
  record: any,
  optionName: string,
  optionChildren: string[]
) => {
  const hasPeriod =
    optionChildren.length > 0 && optionChildren.includes(optionName);
  const periodValue = hasPeriod ? record[optionName + "Period"] : null;

  return (
    <div>
      <span className={s.cont}>{value}</span>
      {periodValue && <div className={s.cont_under}>{periodValue}</div>}
    </div>
  );
};

const renderYesNoCell = (value: any) => {
  return (
    <div>
      <span className={s.cont}>{value ? "Да" : "Нет"}</span>
    </div>
  );
};

export const getEditorStaffColumns = (
  t: TFunction,
  options: string[],
  optionChildren: string[]
): ColumnsType<any> =>
  options.map((option) => {
    const baseColumn = {
      title: t(`editorStaff.${option}`),
      dataIndex: option,
      key: option,
    };

    if (option === "combineTraining" || option === "combineCertification") {
      return {
        ...baseColumn,
        render: (value: any) => renderYesNoCell(value),
      };
    }

    if (optionChildren.includes(option)) {
      return {
        ...baseColumn,
        render: (value: any, record: any) =>
          renderCellWithPeriod(value, record, option, optionChildren),
      };
    }

    return {
      ...baseColumn,
      render: (value: any) => <span className={s.cont}>{value}</span>,
    };
  });
